<template>
    <Apps v-if="page && page.slug =='apps'" :contents="page" />
    <div v-else-if="page" class="w-full">
        <article class="mx-auto w-full max-w-3xl">
            <h1 class="nl-title text-3xl md:text-5xl">{{ page.title }}</h1>
            <p class="mt-3 text-sm text-nomad-400">Last updated {{ page.updated_at }}</p>
            <div class="nl-prose mt-10" v-html="page.content"></div>
        </article>
    </div>
</template>

<script>
import { Link, usePage } from "@inertiajs/vue3";
import { mapState, mapActions, mapGetters } from "vuex";
import CardSong from '@/components/CardSong.vue'
import Apps from '@/Pages/Apps.vue'
export default {
    data() {
        return {
            page: null
        }
    },
    created() {
        this.page = usePage().props.page;
    },
    components: {
        Apps
    }
}
</script>